import { render, staticRenderFns } from "./exclusive.vue?vue&type=template&id=99f9131e"
import script from "./exclusive.vue?vue&type=script&lang=ts"
export * from "./exclusive.vue?vue&type=script&lang=ts"
import style1 from "./exclusive.vue?vue&type=style&index=1&id=99f9131e&prod&module=true&lang=stylus"




function injectStyles (context) {
  
  this["$style"] = (style1.locals || style1)

}

/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports